export const isRegistrationClosed = (gameStartTime: number, currentTime: number, registrationWindow = 10) => {
  const diff = Math.abs(gameStartTime - currentTime)
  const runningTime = parseInt(((diff / (1000 * 60)) % 60).toFixed())
  const isRegistrationClosed = registrationWindow < runningTime

  return isRegistrationClosed
}
